export default __webpack_public_path__ + "static/media/home_img2.c014dda3.svg";